export default "__VITE_ASSET__1b_R1ssd__"